"use client";

import { memo, useMemo } from "react";
import {
	CommunityReviewsList,
	type CommunityReview,
} from "@/components/shared/community-reviews-list";
import { useCommunityShowReviewsInfinite } from "@/hooks/features/show/reviews";
import { useCurrentUserDisplay } from "@/hooks/shared/use-auth";
import { useInfiniteScroll } from "@/hooks/shared/use-infinite-scroll";

interface CommunityShowReviewsCardProps {
	showId: string;
}

export const CommunityShowReviewsCard = memo<CommunityShowReviewsCardProps>(
	function CommunityShowReviewsCard({ showId }) {
		const { data: currentUser } = useCurrentUserDisplay();

		const {
			data,
			fetchNextPage,
			hasNextPage,
			isFetchingNextPage,
			isLoading,
			error,
		} = useCommunityShowReviewsInfinite(showId, {
			limit: 10,
			excludeCurrentUser: true,
		});

		const reviews = useMemo(() => {
			if (!data?.pages || !data.pages[0]) return [];
			return data.pages[0];
		}, [data]);

		useInfiniteScroll({
			fetchNextPage,
			hasNextPage,
			isFetchingNextPage,
			isActive: true,
		});

		return (
			<CommunityReviewsList
				reviews={reviews as CommunityReview[]}
				isLoading={isLoading}
				error={error}
				isAuthenticated={!!currentUser}
				reportContentType="show_review"
				emptyEntityLabel="show"
				isFetchingNextPage={isFetchingNextPage}
			/>
		);
	},
);
